/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: NonNullable<unknown> }} Valve_Head_LooseInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Th. head seems loose" |
* | "true" | "Th. head seems loose since {date}" |
* | * | "Th. head seems loose" |
*
* @param {Valve_Head_LooseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_head_loose = /** @type {((inputs: Valve_Head_LooseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Head_LooseInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Th. head seems loose`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Th. head seems loose since ${i?.date}`);
		return /** @type {LocalizedString} */ (`Th. head seems loose`)
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`La tête thermostatique semble desserrée`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`La tête thermostatique semble desserrée depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ (`La tête thermostatique semble desserrée`)
	}
});